module.exports = __webpack_public_path__ + "images/Zuora-d062bb.png";